import { toastr } from 'react-redux-toastr';

//export default toastr;

const toastrProxy = new Proxy(toastr, {
  get(target, prop) {
    if (prop === 'error') {
      return (...args) => {
        if (location.hash.includes('tv-version')) {
          setTimeout(() => {
            toastr.clean();
          }, 4000);
        }
        return target[prop](...args);
      };
    }
    return (...args) => {
      return target[prop](...args);
    };
  }
});

export default toastrProxy;
